<template>
  <pui-big-preview
    ref="bigPreview"
    :getTitlePicto="getFilePicto"
    :executeConfirmableAction="executeConfirmableAction"
    :executeConfirmableBreakingSave="executeConfirmableBreakingSave"
    :abandonChanges="abandonChanges"
    :valuesAreDirty="valuesAreDirty"
    :importInProgress="importInProgress"
    :saveInProgress="saveInProgress"
    @changeZoomedItem="$emit('changeZoomedItem', $event)"
    class="file-zoom-dialog file-zoom-dialog__root"
  >
    <template #name="{ item }">{{ item.name }}</template>
    <template #viewer="{ item }">
      <pui-dam-viewer-container
        :file="item"
        :attributes="zoomedFileAttributes"
        class="file-zoom-dialog__thumbnail-viewer"
      />
    </template>
    <template #meta="{ item }">
      <pui-file-panel-selection
        ref="panelSelection"
        :isExpanded="false"
        :files="[item]"
        :showPanelControls="false"
        @valuesAreDirty="valuesAreDirty = $event"
        @saveInProgress="saveInProgress = $event"
        @attributeSourceValuesChange="zoomedFileAttributes = $event"
        @importInProgress="importInProgress = $event"
        hideAttributeButtons
        title=""
        class="file-zoom-dialog__panel-selection"
        fileRequestNamespace="zoom-file"
      />
    </template>
  </pui-big-preview>
</template>

<script>
import { getFilePicto } from '../../helpers/fileHelper';
import puiDamViewerContainer from '../viewers/ViewerContainer';
import puiFilePanelSelection from './info/FilePanelSelection';

export default {
  components: {
    puiFilePanelSelection,
    puiDamViewerContainer,
  },
  data() {
    return {
      valuesAreDirty: false,
      importInProgress: false,
      saveInProgress: false,
      zoomedFileAttributes: [],
    };
  },
  methods: {
    getFilePicto,
    // DIALOG
    /**
     * Initializes our state and opens the dialog
     *
     * @param {object[]} files - the files that can be zoomed
     * @param {number} fileIndex - the index of the file that should be zoomed
     */
    open(files, fileIndex) {
      this.$nextTick(() => {
        this.$refs.bigPreview.open(files, fileIndex);
      });
    },
    /**
     * Resets our state and closes the dialog
     */
    close() {
      this.$refs.bigPreview.close();
    },
    // ACTION CALLBACKS
    /**
     * Executes the breaking save hook
     *
     * @param {() => void | Promise<void>} actionCallback - called when the user confirms or abandons the save
     * @returns {Promise<void>} resolves once the user decides to confirm the changes + changes are saved
     */
    executeConfirmableBreakingSave(actionCallback) {
      return this.$refs.panelSelection.executeConfirmableBreakingSave(actionCallback);
    },
    /**
     * Resets the zoom attributes' values
     */
    abandonChanges() {
      this.$refs.panelSelection.abandonChanges();
    },
    // EXPOSED
    // EXPOSED > ATTRIBUTES
    /**
     * Will show a confirmation dialog if there are dirty attributes
     * or something that prevents a save. On save/ignore, the callback will be invoked
     *
     * @param {() => void} actionCallback - the function to call after the user indicates to discard
     * the unsaved changes, or after the changes are saved, or if there is nothing to save at all
     */
    executeConfirmableAction(actionCb) {
      this.$refs.panelSelection.executeConfirmableAction(actionCb);
    },
    /**
     * Updates the form
     */
    refreshZoomForm() {
      // Wait for the panel to receive new files via props
      this.$nextTick(() => {
        if (this.$refs.panelSelection) {
          this.$refs.panelSelection.updateForm();
        }
      });
    },
  },
};
</script>
